import React from "react";

export default React.createContext({ showIngredients: false });
